import { ReactNode } from 'react';

import { useCreateConfigurationContext } from './useCreateConfigurationContext';
import { ConfigurationContext } from './app-config.context';

type ConfigurationProviderProps = {
  children: ReactNode;
};

export const ConfigurationProvider = (props: ConfigurationProviderProps) => {
  const { children } = props;
  const configuration = useCreateConfigurationContext();

  return <ConfigurationContext.Provider value={configuration}>{children}</ConfigurationContext.Provider>;
};
